"use strict";

jQuery( function ($) {
    let addToCartButton = $('[data-sticky-add-to-cart]');

    let sticky = new Waypoint.Sticky({
        element: addToCartButton[0],
        offset: '-200px',
      });
});